import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { ProductsRes } from 'features/products'
import { useQuery } from 'libs/query'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { AuthContext } from 'store'

type UseFetchProductsProps = {
	bookingId?: string
}

export const useFetchProducts = ({ bookingId }: UseFetchProductsProps) => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)

	const {
		data: products,
		isSuccess: isProductsSuccess,
		isLoading: isProductsLoading
	} = useQuery<ProductsRes>({
		queryKey: queryKeys.products.list(`booking_id=${bookingId}`),
		queryFn: () => axiosPrivate.get(apiRoutes.products(`booking_id=${bookingId}`)),
		enabled: !!auth.accessToken
	})

	return {
		products,
		isProductsSuccess,
		isProductsLoading
	}
}
